import PrivacyPolicy from "../../components/footer/PrivacyPolicy";


const PrivacyPolicyView = () => {

    return (
        <div className="privacy-policy">
            <PrivacyPolicy/>
        </div>
    );
};

export default PrivacyPolicyView;